import { authenticatedDelete } from "../../../api/utils/request";

export default async function deleteDoctor(idUser, setErrorMessage) {
  const onError = () => setErrorMessage('No se puede eliminar la usuario');
  return await authenticatedDelete(`/doctor-data/${idUser}`, onError);
}
